import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";

const defaultSelectors = {
    base: '.js-before-after-slider',
    handle: '.js-before-after-slider__handle',
    imageAfter: '.js-before-after-slider__image-after'
};

const defaultOptions = {
    initialPosition: 50,
    keyboardStep: 1
};

function setPosition(imageAfter, handle, position) {
    const clamped = Math.min(100, Math.max(0, position));
    imageAfter.style.clipPath = `inset(0 ${100 - clamped}% 0 0)`;
    handle.style.left = `${clamped}%`;
    handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
}

function getPositionFromClientX(baseElement, clientX) {
    const rect = baseElement.getBoundingClientRect();
    return ((clientX - rect.left) / rect.width) * 100;
}

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        const handle = findIn(selectors.handle, baseElement);
        const imageAfter = findIn(selectors.imageAfter, baseElement);

        if (!handle || !imageAfter) {
            return;
        }

        const opts = {...defaultOptions, ...options};
        let isDragging = false;

        setPosition(imageAfter, handle, opts.initialPosition);

        handle.addEventListener('mousedown', function (e) {
            e.preventDefault();
            isDragging = true;
            baseElement.classList.add('before-after-slider--dragging');
        });

        document.addEventListener('mousemove', function (e) {
            if (!isDragging) return;
            setPosition(imageAfter, handle, getPositionFromClientX(baseElement, e.clientX));
        });

        document.addEventListener('mouseup', function () {
            if (!isDragging) return;
            isDragging = false;
            baseElement.classList.remove('before-after-slider--dragging');
        });

        handle.addEventListener('touchstart', function (e) {
            e.preventDefault();
            isDragging = true;
            baseElement.classList.add('before-after-slider--dragging');
        }, {passive: false});

        document.addEventListener('touchmove', function (e) {
            if (!isDragging) return;
            setPosition(imageAfter, handle, getPositionFromClientX(baseElement, e.touches[0].clientX));
        }, {passive: true});

        document.addEventListener('touchend', function () {
            if (!isDragging) return;
            isDragging = false;
            baseElement.classList.remove('before-after-slider--dragging');
        });

        handle.addEventListener('keydown', function (e) {
            const current = parseFloat(handle.getAttribute('aria-valuenow')) || opts.initialPosition;
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                setPosition(imageAfter, handle, current - opts.keyboardStep);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                setPosition(imageAfter, handle, current + opts.keyboardStep);
            }
        });

        // Allow dragging by clicking anywhere on the slider container
        baseElement.addEventListener('mousedown', function (e) {
            if (e.target === handle || handle.contains(e.target)) return;
            setPosition(imageAfter, handle, getPositionFromClientX(baseElement, e.clientX));
            isDragging = true;
            baseElement.classList.add('before-after-slider--dragging');
        });
    });
}
